import { createApp } from 'vue'
import { createPinia } from 'pinia';
import { router } from '@/router'
import App from './App.vue'

import Notifications from '@kyvg/vue3-notification'

import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';



import './assets/style.scss'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'



const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(Notifications);
app.use(LoadingPlugin);

// import { useCommonStore } from '@/stores';


// function convertRemToPixels(rem) {    
//     return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
// }
// const store = useCommonStore();
// router.options.scrollBehavior = (to, _from, savedPosition) => {
//     if (savedPosition) {
//       return savedPosition;
//     }

//     if (to.hash) {
//       return {
//         el: decodeURI(to.hash),
//         top: store.navHeight+convertRemToPixels(1)+50, // 50 is TopHeaderItem height
//       };
//     }

//     return { x: 0, y: 0 };
//   };



app.mount('#app')

